document.addEventListener('DOMContentLoaded', function () {
  // IDs of the products you want to manage
  const productBlockID = '42980829626461';
  const productLimitID = '42983088488541';
  const MAX_QUANTITY = 2;

  function disableQuantity() {
    // Select all cart items
    const cartItems = document.querySelectorAll('tr.cart-item');

    cartItems.forEach((item) => {
      // Get product ID from quantity input
      const quantityInput = item.querySelector('.quantity__input');
      const itemID = quantityInput?.getAttribute('data-quantity-variant-id');

      if (itemID === productLimitID) {
        if (quantityInput) {
          const currentQuantity = parseInt(quantityInput.value);

          if (currentQuantity >= MAX_QUANTITY) {
            // Disable the input field
            quantityInput.setAttribute('disabled', 'disabled');
            quantityInput.style.backgroundColor = '#f4f4f4';

            // Hide and disable plus button and icon
            const plusButton = item.querySelector('.quantity__button[name="plus"]');
            const plusIcon = item.querySelector('.quantity__button[name="plus"] .plus');

            if (plusButton) {
              plusButton.style.display = 'none';
              plusButton.setAttribute('disabled', 'disabled');
              // Prevent click events
              plusButton.addEventListener(
                'click',
                function (e) {
                  e.preventDefault();
                  e.stopPropagation();
                  return false;
                },
                true
              );
            }

            if (plusIcon) {
              plusIcon.style.display = 'none';
            }
          }
        }
      } else if (itemID === productBlockID) {
        if (quantityInput) {
          // Original product block logic
          quantityInput.setAttribute('disabled', 'disabled');
          quantityInput.style.backgroundColor = '#f4f4f4';

          const quantityButtons = item.querySelectorAll('.quantity__button');
          quantityButtons.forEach((button) => {
            button.style.display = 'none';
            button.setAttribute('disabled', 'disabled');
          });
        }
      }
    });

    // Adicionar listener para o formulário de atualização
    const updateForms = document.querySelectorAll('form[action="/cart/update"]');
    updateForms.forEach((form) => {
      form.addEventListener(
        'submit',
        function (e) {
          const formInputs = form.querySelectorAll('.quantity__input');
          formInputs.forEach((input) => {
            const itemID = input.getAttribute('data-quantity-variant-id');
            if (itemID === productLimitID) {
              const newQuantity = parseInt(input.value);
              if (newQuantity > MAX_QUANTITY) {
                e.preventDefault();
                e.stopPropagation();
                input.value = MAX_QUANTITY;
                return false;
              }
            }
          });
        },
        true
      );
    });
  }

  // Run function immediately
  disableQuantity();

  // Watch for cart changes
  const cartContainer = document.querySelector('#main-cart-items');
  if (cartContainer) {
    const observer = new MutationObserver(disableQuantity);
    observer.observe(cartContainer, {
      childList: true,
      subtree: true,
    });
  }
});
